<div class="advisors-mobile" *ngIf="showAdvisorModal">
  <div class="advisors">
    <app-advisors-doctor></app-advisors-doctor>
  </div>
</div>

<div class="general-search-mobile" *ngIf="showGeneralSearchModal">
  <app-search-mobile (closeModal)="showGeneralSearchModal = false;"></app-search-mobile>
</div>
<mat-sidenav-container class="root-container">
  <mat-sidenav [autoFocus]="false" from="right" [opened]="isOpenMenu" [position]="'start'"
    [disableClose]="!isScreenPhone" [mode]="isScreenPhone ? 'over' : 'side'" class="menu-left background-color-white" [ngClass]="!isScreenPhone ? 'navbar-web':''">
    <div class="content-menu-left">
      <div class="content-menu">
        <div class="top-content">
          <div class="header-logo" *ngIf="!isScreenPhone">
            <img src="./assets/icons/logo-omicron.svg" alt="logo" />
          </div>
          <div class="user-information">
            <div class="image-container-navbar">
              <div class="image cursor-pointer" (click)="openUploadPhoto()">
                <p class="font-omicron-bold mb-0" *ngIf="!existProfilePhoto">
                  {{ initialsName }}
                </p>
                <img [src]="profilePhoto" *ngIf="existProfilePhoto" class="profile-image" alt="profile" />
              </div>
            </div>
            <div class="doctor-name-container">
              <p class="font-omicron-bold color-black pt-1 mb-0 doctor-name title-size-2">
                {{ userName | titlecase }}
              </p>
            </div>
            <p id="btn-my-profile"
              class="title-option mb-0 cursor-pointer my-profile font-omicron-bold font-size-menu text-center w-100"
              [ngClass]="whoRequestMenu.myprofile ? 'active' : ''" (click)="
                goToPage([routes.myProfile, '']);
                menuAccordion.accordionMyProfile = true
              " *ngIf="routesPermissions.menu[0].isShow">
              Mi perfil
            </p>
            <p class="title-option mb-0 cursor-pointer my-profile font-omicron-bold font-size-menu text-center w-100"
              [ngClass]="whoRequestMenu.myprofile ? 'active' : ''" (click)="
                goToPage([routes.myProfile, 'asesor']);
                menuAccordion.accordionMyProfile = true
              " *ngIf="routesPermissions.menu[4].isShow">
              Mi Perfil
            </p>
          </div>
        </div>
        <div class="options" [ngClass]="isScreenPhone ? 'heigth-no-header-logo' : ''">
          <div id="btn-home" class="title-option padding-left-option1 cursor-pointer mat-expansion-panel-header"
            (click)="goToPage([routes.home])" *ngIf="routesPermissions.menu[1].isShow"
            [ngClass]="whoRequestMenu.beginning ? 'active' : ''">
            <img alt="img" src="./assets/icons/inicio.svg" class="icon" />
            <p class="font-omicron-bold font-size-menu">Inicio</p>
          </div>

          <div class="title-option padding-left-option1 cursor-pointer mat-expansion-panel-header"
            (click)="goToPage([routes.promotions])" *ngIf="routesPermissions.menu[10].isShow"
            [ngClass]="whoRequestMenu.promotions ? 'active' : ''">
            <img alt="img" src="./assets/icons/promotions.svg" class="icon" />
            <div class="promotions d-flex">
              <p class="font-omicron-bold font-size-menu font-omicron-bold">Lanzamientos y descuentos</p>
              <span class="new-promotions-alert" *ngIf="observableService.pendingPromotions > 0">¡Nuevas!</span>
              <div class="new-promotions-quantity d-flex justify-content-center align-items-center text-center" *ngIf="observableService.pendingPromotions > 0">
                <p>{{ observableService.pendingPromotions }}</p>
              </div>
            </div>
          </div>

          <mat-accordion hideToggle *ngIf="routesPermissions.menu[2].isShow">
            <mat-expansion-panel [(expanded)]="menuAccordion.accordionGenerateExpanded" (opened)="
                refreshAccordionItems(); menuAccordion.accordionGenerate = true
              " class="mat-elevation-z0">
              <mat-expansion-panel-header class="mat-expansion-panel-header">
                <mat-panel-title class="mr-0">
                  <div class="title-option padding-left-option1"
                    [ngClass]="whoRequestMenu.generateOrder ? 'active' : ''" (click)="goToPage([routes.generateOrder])">
                    <img alt="img" src="./assets/icons/generar_pedido.svg" class="icon" />
                    <p class="font-omicron-bold font-size-menu">
                      Generar pedido
                    </p>
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="subtitle-options">
                <div class="suboption cursor-pointer" [ngClass]="
                    whoRequestMenu.myHistoryOrders &&
                    !menuAccordion.accordionCatalog
                      ? 'active'
                      : ''
                  " (click)="
                    goToPage([routes.historyOrders]);
                    menuAccordion.accordionGenerate = false;
                    menuAccordion.accordionGenerateExpanded = true
                  ">
                  <p class="font-omicron-bold mb-0 padding-left-option2 font-size-menu">
                    Mi historial de pedidos
                  </p>
                </div>
                <mat-accordion hideToggle>
                  <mat-expansion-panel [(expanded)]="menuAccordion.accordionCatalogExpanded" (opened)="
                      refreshAccordionItems();
                      this.menuAccordion.accordionCatalogExpanded = true;
                      this.menuAccordion.accordionCatalog = true;
                      menuAccordion.accordionGenerate = false;
                      menuAccordion.accordionGenerateExpanded = true
                    " class="mat-elevation-z0">
                    <mat-expansion-panel-header class="mat-expansion-panel-header">
                      <mat-panel-title class="mr-0">
                        <div class="suboption cursor-pointer" [ngClass]="
                            menuAccordion.accordionCatalog ? 'active' : ''
                          " (click)="
                            goToPage([routes.catalogClassifications]);
                            menuAccordion.accordionGenerateExpanded = true;
                            whoRequestMenu.dermazone = false;
                            whoRequestMenu.reve = false;
                            whoRequestMenu.bioEqual = false;
                            whoRequestMenu.bioElite = false
                          ">
                          <p class="font-omicron-bold mb-0 padding-left-option2 font-size-menu">
                            Catálogos
                          </p>
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="option" *ngFor="let clasification of listClasificationCatalog">
                      <p class="font-omicron-bold mb-0 suboption padding-left-option3 cursor-pointer font-size-menu"
                        [class.active]="isActive('/products-list/' + clasification.catalogName)" (click)="
                        goToPage([routes.listProduct, clasification.catalogName]);
                        this.menuAccordion.accordionCatalogExpanded = true;
                        menuAccordion.accordionGenerate = false;
                        menuAccordion.accordionGenerateExpanded = true">
                        {{ clasification.description }}
                      </p>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
            </mat-expansion-panel>
          </mat-accordion>

          <mat-accordion hideToggle *ngIf="routesPermissions.menu[3].isShow">
            <mat-expansion-panel [(expanded)]="menuAccordion.accordionMyOrdersExpanded" (opened)="
                refreshAccordionItems(); menuAccordion.accordionMyOrders = true
              " class="mat-elevation-z0">
              <mat-expansion-panel-header class="mat-expansion-panel-header">
                <mat-panel-title class="mr-0">
                  <div id="btn-orders-sidenav" class="title-option padding-left-option1"
                    [ngClass]="menuAccordion.accordionMyOrders ? 'active' : ''">
                    <img alt=" img" src="./assets/icons/pedidos.svg" class="icon" />
                    <p class="font-omicron-bold font-size-menu">Mis pedidos</p>
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="subtitle-options">
                <div id="btn-pending-orders" class="suboption cursor-pointer"
                  [ngClass]="whoRequestMenu.pendingOrder ? 'active' : ''" (click)="
                    goToPage([routes.pendingOrder]);
                    menuAccordion.accordionMyOrders = false;
                    menuAccordion.accordionMyOrdersExpanded = true
                  ">
                  <p class="font-omicron-bold mb-0 padding-left-option2 font-size-menu">
                    Mis órdenes pendientes
                  </p>
                </div>

                <div id="btn-active-orders" class="suboption cursor-pointer"
                  [ngClass]="whoRequestMenu.myActiveOrders ? 'active' : ''" (click)="
                    goToPage([routes.activeOrders]);
                    menuAccordion.accordionMyOrders = false;
                    menuAccordion.accordionMyOrdersExpanded = true
                  ">
                  <p class="font-omicron-bold mb-0 padding-left-option2 font-size-menu">
                    Mis pedidos activos
                  </p>
                </div>
                <div id="btn-delivered-orders" class="suboption cursor-pointer"
                  [ngClass]="whoRequestMenu.mydeliveredOrders ? 'active' : ''" (click)="
                    goToPage([routes.deliveredOrders]);
                    menuAccordion.accordionMyOrders = false;
                    menuAccordion.accordionMyOrdersExpanded = true
                  ">
                  <p class="font-omicron-bold mb-0 padding-left-option2 font-size-menu">
                    Mis pedidos entregados
                  </p>
                </div>

                <div id="btn-record-orders" class="suboption cursor-pointer"
                  [ngClass]="whoRequestMenu.myHistoryOrders ? 'active' : ''" (click)="
                    goToPage([routes.historyOrders]);
                    menuAccordion.accordionMyOrders = false;
                    menuAccordion.accordionMyOrdersExpanded = true
                  ">
                  <p class="font-omicron-bold mb-0 padding-left-option2 font-size-menu">
                    Mi historial de pedidos
                  </p>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>

          <div class="title-option padding-left-option1 cursor-pointer"
            [ngClass]="menuAccordion.accordionDoctorList ? 'active' : ''" (click)="
              goToPage([routes.doctorList]);
              menuAccordion.accordionDoctorList = true
            " *ngIf="routesPermissions.menu[4].isShow">
            <img alt="img" src="./assets/icons/clientes.svg" class="icon" />
            <p class="font-omicron-bold font-size-menu">Clientes</p>
          </div>

          <mat-accordion hideToggle *ngIf="routesPermissions.menu[7].isShow">
            <mat-expansion-panel [(expanded)]="menuAccordion.accordionUtilitiesExpanded" (opened)="
                refreshAccordionItems(); menuAccordion.accordionUtilities = true
              " class="mat-elevation-z0">
              <mat-expansion-panel-header class="mat-expansion-panel-header">
                <mat-panel-title class="mr-0">
                  <div class="title-option padding-left-option1"
                    [ngClass]="menuAccordion.accordionUtilities ? 'active' : ''">
                    <img alt="img" src="./assets/icons/my_store.svg" class="icon" />
                    <p class="font-omicron-bold font-size-menu">Mi negocio</p>
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="subtitle-options">
                <div class="suboption cursor-pointer" [ngClass]="whoRequestMenu.utilities ? 'active' : ''" (click)="
                    goToPage([routes.utilities]);
                    menuAccordion.accordionUtilities = false;
                    menuAccordion.accordionUtilitiesExpanded = true
                  ">
                  <p class="font-omicron-bold mb-0 padding-left-option2 font-size-menu">
                    Mis precios públicos
                  </p>
                </div>
              </div>
              <div class="subtitle-options">
                <div class="suboption cursor-pointer" [ngClass]="whoRequestMenu.analysisBusiness ? 'active' : ''" (click)="
                    goToPage([routes.analysisBusiness]);
                    menuAccordion.accordionUtilities = false;
                    menuAccordion.accordionUtilitiesExpanded = true
                  ">
                  <p class="font-omicron-bold mb-0 padding-left-option2 font-size-menu">
                    Análisis actual de mi negocio
                  </p>
                </div>
              </div>
              <div class="subtitle-options">
                <div class="suboption cursor-pointer" [ngClass]="whoRequestMenu.potencialBusiness ? 'active' : ''" (click)="
                    goToPage([routes.potencialBusiness]);
                    menuAccordion.accordionUtilities = false;
                    menuAccordion.accordionUtilitiesExpanded = true
                  ">
                  <p class="font-omicron-bold mb-0 padding-left-option2 font-size-menu">
                    Potencial de mi negocio
                  </p>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>

          <div class="title-option padding-left-option1 cursor-pointer mat-expansion-panel-header"
            [ngClass]="whoRequestMenu.invoicesPaid ? 'active' : ''" (click)="
              goToPage([routes.invoicesPaid]);
              menuAccordion.accordionInvoice = true
            " *ngIf="routesPermissions.menu[6].isShow">
            <img alt="img" src="./assets/icons/invoices.svg" class="icon" />
            <p class="font-omicron-bold font-size-menu">Mis facturas</p>
          </div>

          <div class="title-option padding-left-option1 cursor-pointer mat-expansion-panel-header"
            [ngClass]="menuAccordion.accountState ? 'active' : ''" (click)="
              goToPage([routes.invoicesPending]);
              menuAccordion.accountState = true
            " *ngIf="routesPermissions.menu[6].isShow">
            <img alt="img" src="./assets/icons/accountStatus.svg" class="icon" />
            <p class="font-omicron-bold font-size-menu">Cuentas por pagar</p>
          </div>

          <div class="title-option padding-left-option1 cursor-pointer mat-expansion-panel-header"
            (click)="openPage(whatsAppUrl)" *ngIf="isScreenPhone && isDoctor">
            <img alt="img" src="./assets/icons/whastappmenu-blue.svg" class="icon" />
            <p class="font-omicron-bold font-size-menu">Ayuda WhatsApp</p>
          </div>

          <div class="title-option padding-left-option1 cursor-pointer mat-expansion-panel-header"
            (click)="openPage(webbinarUrl)" *ngIf="routesPermissions.menu[16].isShow">
            <img alt="img" src="./assets/icons/webinar.svg" class="icon" />
            <p class="font-omicron-bold font-size-menu">Webinar</p>
          </div>

          <mat-accordion hideToggle *ngIf="routesPermissions.menu[8].isShow">
            <mat-expansion-panel [(expanded)]="menuAccordion.accordionSalesExpanded" class="mat-elevation-z0"
              (opened)="refreshAccordionItems(); menuAccordion.accordionSales = true">
              <mat-expansion-panel-header class="mat-expansion-panel-header">
                <mat-panel-title class="mr-0">
                  <div class="title-option padding-left-option1"
                    [ngClass]="menuAccordion.accordionSales ? 'active' : ''">
                    <img alt="img" src="./assets/icons/sales.svg" class="icon" />
                    <p class="font-omicron-bold font-size-menu">Ventas</p>
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="subtitle-options">
                <!-- <div class="suboption cursor-pointer" [ngClass]="whoRequestMenu.averageTicket ? 'active' : ''" (click)="goToPage([routes.averageTicket]);
                menuAccordion.accordionSales = false;
                menuAccordion.accordionSalesExpanded = true;">
                  <p class="font-omicron-bold mb-0 padding-left-option2 font-size-menu">
                    Ticket promedio
                  </p>
                </div> -->

                <div class="suboption cursor-pointer" [ngClass]="whoRequestMenu.goals ? 'active' : ''" (click)="goToPage([routes.goals]);
                menuAccordion.accordionSales = false;
                menuAccordion.accordionSalesExpanded = true;">
                  <p class="font-omicron-bold mb-0 padding-left-option2 font-size-menu">
                    Metas
                  </p>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>

          <div class="title-option padding-left-option1 cursor-pointer"
            [ngClass]="menuAccordion.accordionMissingProducts ||whoRequestMenu.missingProducts ? 'active' : ''" (click)="
              goToPage([routes.missingProducts]);
              menuAccordion.accordionMissingProducts = true" *ngIf="routesPermissions.menu[9].isShow">
            <img alt="img" src="./assets/icons/missingProduct.svg" class="icon" />
            <p class="font-omicron-bold font-size-menu">Lista de faltantes</p>
          </div>



          <mat-accordion hideToggle *ngIf="routesPermissions.menu[11].isShow">
            <mat-expansion-panel [(expanded)]="menuAccordion.accordionSapReportsExpandex" class="mat-elevation-z0"
              (opened)="refreshAccordionItems(); menuAccordion.accordionSapReports = true">
              <mat-expansion-panel-header class="mat-expansion-panel-header">
                <mat-panel-title class="mr-0">
                  <div class="title-option padding-left-option1"
                    [ngClass]="menuAccordion.accordionSapReports ? 'active' : ''">
                    <img alt="img" src="./assets/icons/reports.svg" class="icon" />
                    <p class="font-omicron-bold font-size-menu">Reportes</p>
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="subtitle-options">
                <div class="suboption cursor-pointer" [ngClass]="whoRequestMenu.clientsWallet ? 'active' : ''" (click)="goToPage([routes.clientsWallet]); menuAccordion.accordionSapReports = false;
                menuAccordion.accordionSapReportsExpandex = true; ">
                  <p class="font-omicron-bold mb-0 padding-left-option2 font-size-menu">
                    Cartera de Clientes
                  </p>
                </div>

                <div class="suboption cursor-pointer" [ngClass]="whoRequestMenu.paymentsAndBillings ? 'active' : ''"
                  (click)="goToPage([routes.paymentAndBillings]); menuAccordion.accordionSapReports = false;
                  menuAccordion.accordionSapReportsExpandex = true">
                  <p class="font-omicron-bold mb-0 padding-left-option2 font-size-menu">
                    Pagos y Facturas
                  </p>
                </div>

                <div class="suboption cursor-pointer" [ngClass]="whoRequestMenu.tradeCube ? 'active' : ''" (click)="goToPage([routes.tradeCube]); menuAccordion.accordionSapReports = false;
                  menuAccordion.accordionSapReportsExpandex = true ">
                  <p class="font-omicron-bold mb-0 padding-left-option2 font-size-menu">
                    Cubo Comercial
                  </p>
                </div>
                <div class="suboption cursor-pointer" [ngClass]="whoRequestMenu.openOrdersReport ? 'active' : ''"
                  (click)="goToPage([routes.openOrdersReport]); menuAccordion.accordionSapReports = false;
                  menuAccordion.accordionSapReportsExpandex = true ">
                  <p class="font-omicron-bold mb-0 padding-left-option2 font-size-menu">
                    Seguimiento de partidas abiertas
                  </p>
                </div>

              </div>
            </mat-expansion-panel>
          </mat-accordion>



          <mat-accordion hideToggle *ngIf="routesPermissions.menu[12].isShow">
            <mat-expansion-panel [(expanded)]="menuAccordion.accordionCatalogExpanded" (opened)="refreshAccordionItems();
            menuAccordion.accordionCatalogExpanded = true;
            menuAccordion.accordionCatalog = true;" class="mat-elevation-z0">
              <mat-expansion-panel-header class="mat-expansion-panel-header">
                <mat-panel-title class="mr-0">
                  <div class="title-option padding-left-option1"
                    [ngClass]="menuAccordion.accordionCatalog ? 'active' : ''" (click)="goTo(routes.advisorCatalogsClassification);
                            menuAccordion.accordionCatalog = true;
                            whoRequestMenu.dermazone = false;
                            whoRequestMenu.reve = false;
                            whoRequestMenu.bioEqual = false;
                            whoRequestMenu.bioElite = false
                          ">
                    <img alt="img" src="assets/icons/generar_pedido.svg" class="icon" />
                    <p class="font-omicron-bold font-size-menu">Catálogos</p>
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="subtitle-options" *ngFor="let clasification of listClasificationCatalog">
                <p class="font-omicron-bold mb-0 suboption padding-left-option3 cursor-pointer font-size-menu"
                  [class.active]="isActive('/advisor-catalogs/' + clasification.catalogName)" (click)="
                  goToPage([routes.advisorCatalog, clasification.catalogName]);
                  this.menuAccordion.accordionCatalogExpanded = true;
                  menuAccordion.accordionGenerate = false;
                  menuAccordion.accordionGenerateExpanded = true">
                  {{ clasification.description }}
                </p>
              </div>
              
            </mat-expansion-panel>
          </mat-accordion>




          <mat-accordion hideToggle *ngIf="routesPermissions.menu[15].isShow">
            <mat-expansion-panel [(expanded)]="menuAccordion.accordionCodePromoExpandex"
              (opened)="refreshAccordionItems(); menuAccordion.codePromo = true; menuAccordion.accordionCodePromoExpandex = true"
              class="mat-elevation-z0 mt-3">
              <mat-expansion-panel-header class="mat-expansion-panel-header">
                <mat-panel-title class="mr-0">
                  <div id="btn-orders-sidenav" class="title-option padding-left-option1"
                    [ngClass]="menuAccordion.codePromo ? 'active' : ''">
                    <img alt=" img" src="./assets/icons/promotionCodes.svg" class="icon" />
                    <p class="font-omicron-bold font-size-menu">Código promocional</p>
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="subtitle-options">
                <div id="btn-pending-orders" class="suboption cursor-pointer"
                  [ngClass]="whoRequestMenu.managePromotionsCode ? 'active' : ''"
                  (click)="goToPage([routes.managePromotionCodes]); menuAccordion.codePromo = false; menuAccordion.accordionCodePromoExpandex = true;">
                  <p class="font-omicron-bold mb-0 padding-left-option2 font-size-menu">
                    Administrar código
                  </p>
                </div>
              </div>

              <div class="subtitle-options">
                <div id="btn-pending-orders" class="suboption cursor-pointer"
                  [ngClass]="whoRequestMenu.createPromotionCode ? 'active' : ''"
                  (click)="goToPage([routes.createPromotionCode]); menuAccordion.codePromo = false; menuAccordion.accordionCodePromoExpandex = true;">
                  <p class="font-omicron-bold mb-0 padding-left-option2 font-size-menu">
                    Generar código promocional
                  </p>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>

          <div class="title-option padding-left-option1 cursor-pointer"
            [ngClass]="whoRequestMenu.quotation ? 'active' : ''" (click)="
            goToPage([routes.quotation]);
            whoRequestMenu.quotation = true
          " *ngIf="routesPermissions.menu[14].isShow">
            <img alt="img" src="assets/icons/quotation_menu.svg" class="icon" />
            <p class="font-omicron-bold font-size-menu">Generar cotización</p>
          </div>

        </div>
      </div>

      <div class="footer-menu">
        <div class="faqs padding-left-option1 cursor-pointer active"
          [ngClass]="{'border-bottom-faqs':isDoctor, 'active': whoRequestMenu.faqs}"
          *ngIf="routesPermissions.menu[13].isShow" (click)="goToPage([routes.faqs])">
          <img src="./assets/icons/faqs.svg" alt="fragile" class="icon" />
          <p class="mb-0 font-omicron-bold mat-expansion-panel-header font-size-menu">
            FAQ'S
          </p>
        </div>
        <div class="incidents padding-left-option1 cursor-pointer " [ngClass]="{'active': whoRequestMenu.incidents}"
          *ngIf="routesPermissions.menu[5].isShow" (click)="goToPage([routes.incidents])">
          <img src="./assets/icons/fragile.svg" alt="fragile" class="icon" />
          <p class="mb-0 font-omicron-bold mat-expansion-panel-header font-size-menu">
            Buzón de Incidencias
          </p>
        </div>
        <div class="logout-container mx-2">
          <div id="btn-logout" class="logout-button cursor-pointer br-button blue-button" (click)="logout()">
            <img alt="img" src="./assets/icons/cerrar_sesion.svg" />
            <div>
              <p class="font-omicron-bold mb-0 font-size-button">
                Cerrar sesión
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav>

  <mat-sidenav-content class="full-container">
    <mat-toolbar class="header" *ngIf="
    activeRol === roles.doctor || 
    isScreenPhone && activeRol === roles.adminPromo || 
    isScreenPhone && activeRol === roles.reporter ||
    isScreenPhone && activeRol === roles.advisor">

      <div class="d-flex justify-content-between width-100" *ngIf="isScreenPhone">
        <div class="d-flex align-items-center">
          <img src="assets/icons/menu.svg" class="logo-omicron-menu menu-icon-toggle cursor-pointer" alt="logo"
            (click)="toggleMenu()" />
          <mat-icon class="color-omicron pl-2" *ngIf="isDoctor"
            (click)="showGeneralSearchModal = true;">search</mat-icon>
        </div>

        <img class="logo-omicron-mobile" src="assets/icons/logo-omicron.svg" alt="logo-omicron.svg" />

        <div class="d-flex align-items-center">
          <div class="advisor-button pr-1" (click)="showAdvisorModal = true" *ngIf="isDoctor">
            <img src="assets/icons/headphones.svg" alt="headphones" />
            <p class="mb-0 text-size-1">Asesor</p>
          </div>

          <app-shopping-cart-button-header [totalPieces]="totalPieces" [isScreenPhone]="isScreenPhone"
            (click)="goToPage([routes.shoppingCar])" *ngIf="isShoppingCartShow && isDoctor">
          </app-shopping-cart-button-header>
        </div>
      </div>

      <div class="d-flex justify-content-between width-100" *ngIf="!isScreenPhone">
        <div class="flex-grow-1">
          <app-general-search *ngIf="activeRol === roles.doctor"></app-general-search>
        </div>

        <div class="doctor-web-information" *ngIf="isDoctor">
          <p class="text-size-1 mb-0 color-omicron font-omicron-bold cursor-pointer line-bottom"
            [ngClass]="showBar ? 'show-bar' : ''" [matMenuTriggerFor]="menu" (menuOpened)="showBar = true"
            (menuClosed)="showBar = false">
            Asesor
          </p>
          <mat-menu #menu="matMenu">
            <div class="advisor-web-dialog" *ngFor="let advisor of advisors">
              <p class="font-omicron-bold color-black text-size-1">{{ advisor.line?.toUpperCase() ===
                typeListProduct.Omigenomics?.toUpperCase() ? 'Tu asesor Omigenomics es':'Tu asesor es' }}</p>
              <div class="advisor-container-info row no-padding no-margin">
                <div class="col-2 pl-0">
                  <div class="advisor-image">
                    <div class="no-image-advisor" *ngIf="
                advisor.profilePictureUrl === '' ||
                advisor.profilePictureUrl === null ||
                advisor.profilePictureUrl === undefined
              ">
                      <p class="mb-0">{{ advisor.initials }}</p>
                    </div>
                    <img [src]="advisor.profilePictureUrl" alt="perfil image" *ngIf="
                advisor.profilePictureUrl !== '' &&
                advisor.profilePictureUrl !== null &&
                advisor.profilePictureUrl !== undefined
              " />
                  </div>
                </div>

                <div class="col-5 px-0">
                  <p class="mb-0 font-omicron-bold color-omicron title-size-4">
                    {{ advisor.name }} {{ advisor.middleName }}
                    {{ advisor.lastName }}
                  </p>
                </div>

                <div class="col-5 pr-0 advisor-data">
                  <p class="mb-0 text-size-2 advisor-email">{{ advisor.email }}</p>
                  <div class="phone-advisor">
                    <img src="assets/icons/whatapp-green.svg" alt="whatssapp" />
                    <p class="mb-0 text-size-2">{{ advisor.cellPhone }}</p>
                  </div>
                </div>
              </div>
            </div>
          </mat-menu>
          <div>
            <p class="color-omicron font-omicron-bold pending-order-bar cursor-pointer text-size-1"
              (click)="goTo(routesString.pendingOrder)">
              Órdenes pendientes:
              <span class="color-black text-size-1">{{ counters.Pendiente }}</span>
            </p>
          </div>
          <p class="text-size-1 mb-0 color-omicron font-omicron-bold cursor-pointer"
            (click)="goTo(routesString.activeOrders)">
            Pedidos activos:
            <span class="color-black text-size-1">{{ counters.Activo }}</span>
          </p>
          <div class="d-flex align-items-center cursor-pointer" (click)="openPage(whatsAppUrl)">
            <p class="text-size-1 mb-0 color-omicron font-omicron-bold">
              Ayuda WhatsApp
            </p>
            <img class="pl-1" src="assets/icons/whastappmenu-green.svg" alt="whatssapp" />
          </div>
          <div *ngIf="isShoppingCartShow && isDoctor">
            <app-shopping-cart-button-header [totalPieces]="totalPieces" [isScreenPhone]="isScreenPhone"
              (click)="goToPage([routes.shoppingCar])">
            </app-shopping-cart-button-header>
          </div>
        </div>
      </div>
    </mat-toolbar>

    <div class="content-root">
      <div [ngClass]="isDoctor ? 'doctor' : ' '" class="content-general">
        <div *ngIf="isHeaderClient" class="header-client" #headerClient>
          <app-client-header [clientDoctorModel]="clientAdviser"></app-client-header>
        </div>
        <div [ngClass]="isHeaderClient ? 'content-page' : 'content-page-full'" [ngClass]="
            !isDoctor ? 'content-page-adviser-reporter' : 'content-page-full'
          " #contentPage>
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </mat-sidenav-content>

</mat-sidenav-container>
<ngx-spinner [name]="spinnerName" bdColor="rgba(0, 0, 0, 0.8)" size="large" color="#fff" type="ball-clip-rotate-pulse"
  [fullScreen]="true">
  <p style="color: white">Loading...</p>
</ngx-spinner>